<template>
    <v-dialog v-model="getPassportViewer" persistent max-width="1050px">
        <v-card height="775px">
            <v-card-title class="d-flex align-center justify-center black--text px-0 py-0">
                <v-row no-gutters class="py-2">
                    <v-col cols="1" align="center"></v-col>
                    <v-col cols="10" align="center" align-self="center">{{ $t('header') }}</v-col>
                    <v-col cols="1" align="end" class="pr-2"><v-icon color="error" x-large
                            @click="$store.commit('setPassportViewer', false)">mdi-close-circle-outline</v-icon></v-col>
                </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="max-height: 710px; overflow-y: auto;" class="black--text">
                <v-row no-gutters class="my-5">
                    <v-col cols="6">
                        <h3 class="secondary--text text-decoration-underline">{{ $t('section1Header') }}</h3>
                        <br>
                        <ul>
                            <li>{{ $t('section11') }}</li>
                            <li>{{ $t('section12') }}</li>
                            <li>{{ $t('section13') }}</li>
                            <li>{{ $t('section14') }}</li>
                            <li>{{ $t('section15') }}</li>
                            <li><strong>{{ $t('section16') }}</strong></li>
                        </ul>
                    </v-col>
                    <v-col cols="6">
                        <h3 class="secondary--text text-decoration-underline">{{ $t('section2Header') }}
                        </h3>
                        <br>
                        <ul>
                            <li>{{ $t('section21') }}</li>
                            <li>{{ $t('section22') }}</li>
                            <li>{{ $t('section23') }}</li>
                            <li>{{ $t('section24') }}</li>
                            <li>{{ $t('section25') }}</li>
                            <li>{{ $t('section26') }}</li>
                            <li>{{ $t('section27') }}</li>
                            <li><strong>{{ $t('section28') }}</strong></li>
                        </ul>
                    </v-col>
                    <v-col cols="6" class="mt-5">
                        <h3 class="secondary--text text-decoration-underline">{{ $t('section3Header') }}
                        </h3>
                        <br>
                        <ul>
                            <li>{{ $t('section31') }}</li>
                            <li>{{ $t('section32') }}</li>
                            <li>{{ $t('section33') }}</li>
                            <li>{{ $t('section34') }}</li>
                            <li>{{ $t('section35') }}</li>
                            <li>{{ $t('section36') }}</li>
                            <li>{{ $t('section37') }}</li>
                            <li><strong>{{ $t('section38') }}</strong></li>
                        </ul>
                    </v-col>
                    <v-col cols="6" class="mt-5">
                        <h3 class="secondary--text text-decoration-underline">{{ $t('section4Header') }}</h3>
                        <br>
                        <ul>
                            <li>{{ $t('section41') }}</li>
                            <li>{{ $t('section42') }}</li>
                            <li>{{ $t('section43') }}</li>
                            <li>{{ $t('section44') }}</li>
                            <li>{{ $t('section45') }}</li>
                            <li>{{ $t('section46') }}</li>
                            <li>{{ $t('section47') }}</li>
                        </ul>
                    </v-col>
                </v-row>
                <p><strong>{{ $t('noteHeader') }}:</strong> {{ $t('note') }}</p>

                <p><strong>{{ $t('lostPassportHeader') }}:</strong> {{ $t('lostPassport') }}</p>

                <p><strong>{{ $t('minorApplyHeader') }}:</strong> {{ $t('minorApply') }}</p>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "passportViewer",
    computed: {
        ...mapGetters(["getPassportViewer"]),
    },
}
</script>
<i18n>
{
  "en": {
      "header": "Passport Appliation Requirements",
      "section1Header": "First Time Applicant – Adult",
      "section11": "DS-11 Form",
      "section12": "Original Birth Certificate",
      "section13": "Driver's License or State ID",
      "section14": "Check or Money Order only for Passport Fee",
      "section15": "Cash or Money Order only for Application Fee",
      "section16": "No Debit or Credit Cards Accepted",
      "section2Header": "All Minor Applicants – 15 Years & Under",
      "section21": "DS-11 Form",
      "section22": "Applicant Must be Present",
      "section23": "Original Birth Certificate",
      "section24": "Parent(s) on Original Birth Certificate Must be Present",
      "section25": "Parent's Driver's License or State ID",
      "section26": "Check or Money Order only for Passport Fee",
      "section27": "Cash or Money Order only for Application Fee",
      "section28": "No Debit or Credit Cards Accepted",
      "section3Header": "All Minor Applicants – 16 & 17 Years Old",
      "section31": "DS-11 Form",
      "section32": "Applicant Must be Present",
      "section33": "Original Birth Certificate",
      "section34": "Only one Parent is Required to be Present",
      "section35": "Applicant and Parent's Driver's License and/or State ID",
      "section36": "Check or Money Order only for Passport Fee",
      "section37": "Cash or Money Order only for Application Fee",
      "section38": "No Debit or Credit Cards Accepted",
      "section4Header": "Renewal Applicant – Adults Only",
      "section41": "DS-82 Form",
      "section42": "Expired Passport Book must Accompany Application",
      "section43": "Check or Money Order only for Passport Fee",
      "section44": "New Photo",
      "section45": "No Application Fee is Required",
      "section46": "Must Sign and Date Application Form",
      "section47": "Mail Passport Application with Tracking",
      "noteHeader": "Note",
      "note": "Expired Passport Eligible for Renewal Must be no More Than 15 Years from the Date of Issuance.",
      "lostPassportHeader": "Lost or Stolen Passport",
      "lostPassport": "Applicant Must Complete Forms DS-11 and DS-64.",
      "minorApplyHeader": "Minors Applying with Only One Parent Present",
      "minorApply":"Must Use a Statement of Consent (Form DS-3053). It Must be Notarized and Front and Back of Absent Parent’s Driver’s License, State ID, or Passport Must be Attached."
    },
  "es":{
      "header": "Requisitos para la Solicitud de Pasaporte",
      "section1Header": "Primer Solicitante – Adulto",
      "section11": "Formulario DS-11",
      "section12": "Certificado de nacimiento original",
      "section13": "Licencia de conducir o identificación estatal",
      "section14": "Cheque o giro postal solo para la tarifa del pasaporte",
      "section15": "Efectivo o giro postal solo para la tarifa de la solicitud",
      "section16": "No se aceptan tarjetas de débito ni de crédito",
      "section2Header": "Todos los Solicitantes Menores – 15 años o menos",
      "section21": "Formulario DS-11",
      "section22": "El solicitante debe estar presente",
      "section23": "Certificado de nacimiento original",
      "section24": "El(los) padre(s) en el certificado de nacimiento original deben estar presentes",
      "section25": "Licencia de conducir o identificación estatal del padre/madre",
      "section26": "Cheque o giro postal solo para la tarifa del pasaporte",
      "section27": "Efectivo o giro postal solo para la tarifa de la solicitud",
      "section28": "No se aceptan tarjetas de débito ni de crédito",
      "section3Header": "Todos los Solicitantes Menores – 16 y 17 años",
      "section31": "Formulario DS-11",
      "section32": "El solicitante debe estar presente",
      "section33": "Certificado de nacimiento original",
      "section34": "Solo se requiere la presencia de uno de los padres",
      "section35": "Licencia de conducir y/o identificación estatal del solicitante y del padre/madre",
      "section36": "Cheque o giro postal solo para la tarifa del pasaporte",
      "section37": "Efectivo o giro postal solo para la tarifa de la solicitud",
      "section38": "No se aceptan tarjetas de débito ni de crédito",
      "section4Header": "Renovación de Pasaporte – Solo Adultos",
      "section41": "Formulario DS-82",
      "section42": "El pasaporte vencido debe acompañar la solicitud",
      "section43": "Cheque o giro postal solo para la tarifa del pasaporte",
      "section44": "Foto nueva",
      "section45": "No se requiere tarifa de solicitud",
      "section46": "El formulario de solicitud debe estar firmado y fechado",
      "section47": "Enviar la solicitud de pasaporte con número de seguimiento",
      "noteHeader": "Nota",
      "note": "El pasaporte vencido elegible para renovación no debe tener más de 15 años desde la fecha de emisión.",
      "lostPassportHeader": "Pasaporte perdido o robado",
      "lostPassport": "El solicitante debe completar los formularios DS-11 y DS-64.",
      "minorApplyHeader": "Menores que solicitan con solo un padre presente",
      "minorApply":"Se debe usar una Declaración de Consentimiento (Formulario DS-3053). Debe estar notariada y se debe adjuntar el frente y dorso de la licencia de conducir, identificación estatal o pasaporte del padre/madre ausente."
    }
}    
</i18n>